import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
export default class HeroWithSlider {
    constructor() {
        this.slider = document.querySelector('.swiper--block-hero-with-slider');
        this.navigationPrev = document.querySelector('.slider-button-prev--block-hero-with-slider');
        this.navigationNext = document.querySelector('.slider-button-next--block-hero-with-slider');

        this.ready();
    }

    ready() {
        const swiper = new Swiper(this.slider, {
            modules: [Navigation],
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 0,
            allowTouchMove: true,
            autoHeight: false,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
        });
    }
}

if (document.querySelector('.block-hero-with-slider')) {
    new HeroWithSlider();
}
